
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Plus } from "lucide-react";
import { DomainTag } from "./DomainTag";
import { isValidDomain } from "./domainUtils";

interface DomainManagementProps {
  domains: string[];
  onDomainsChange: (domains: string[]) => void;
}

export const DomainManagement = ({ domains, onDomainsChange }: DomainManagementProps) => {
  const [newDomain, setNewDomain] = useState("");

  const handleAddDomain = () => {
    if (!newDomain) return;
    
    // Validate domain format
    if (!isValidDomain(newDomain)) {
      alert("Please enter a valid domain (e.g., example.com)");
      return;
    }
    
    // Add domain if it doesn't already exist
    if (!domains.includes(newDomain)) {
      onDomainsChange([...domains, newDomain]);
      setNewDomain("");
    } else {
      alert("This domain has already been added");
    }
  };
  
  const handleRemoveDomain = (domain: string) => {
    onDomainsChange(domains.filter(d => d !== domain));
  };

  return (
    <div>
      <Label htmlFor="domains-section" className="text-base font-semibold">
        Company Domains
      </Label>
      <p className="text-xs text-muted-foreground mt-1 mb-2">
        Only email addresses from these domains will be allowed to join this company
      </p>
      
      <div className="flex gap-2">
        <Input 
          placeholder="example.com"
          value={newDomain}
          onChange={(e) => setNewDomain(e.target.value)}
          className="flex-1"
        />
        <Button 
          type="button" 
          onClick={handleAddDomain}
          size="icon"
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="flex flex-wrap gap-2 mt-2">
        {domains.map(domain => (
          <DomainTag 
            key={domain} 
            domain={domain} 
            onRemove={handleRemoveDomain} 
          />
        ))}
        {domains.length === 0 && (
          <p className="text-xs text-muted-foreground italic">No domains added</p>
        )}
      </div>
    </div>
  );
};
